import Qr from './Qr';

function App() {
  return (
    <div className="App">
      <Qr />
    </div>
  );
}

export default App;
